// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__3vxzv","list_item":"styles_list_item__3eYOH","more":"styles_more__1r7WX"};